import React from "react";
import whoWeAreIcon from "../assets/whoe-we-are-icon.webp";

const WhoWeAre: React.FC = () => {
  return (
    <div className="w-full pt-[70px] pb-[40px] md:py-[90px] bg-white">
      <div className="max-w-[1710px] mx-auto px-[20px]">
        <div className="flex flex-col md:flex-row items-center gap-[56px]">
          {/* Icon Section */}
          <div className="pl-[15px]">
            <img
              src={whoWeAreIcon}
              alt="Who We Are - PPE.US"
              className="w-[138px] h-[138px] object-contain"
              loading="lazy"
            />
          </div>

          {/* Content Section */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-[32px] md:text-[35px] font-medium text-[#2b2b2b] mb-[18px]">
              Who We Are
            </h2>
            <div className="text-[#2d233c] text-base md:text-[19px]">
              <p>
                Your team's safety is our top priority. We are your reliable
                partner for your PPE needs, and we pride ourselves on vetting
                our manufacturer and supplier partners to ensure product
                quality, competitive pricing, and guaranteed in-hands dates for
                our clients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
